import { useEffect, useState } from 'react';
import { supabase } from '@/src/lib/supabase';

export function useOrgId(venueId: string | null) {
  const [orgId, setOrgId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!venueId) {
      setOrgId(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from('venues')
        .select('organization_id')
        .eq('id', venueId)
        .maybeSingle();
      if (cancelled) return;
      setOrgId((data?.organization_id as string | undefined) ?? null);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [venueId]);

  return { orgId, loading };
}
